import { render, staticRenderFns } from "./InquiryDetailFormConfirm.vue?vue&type=template&id=84132b28&"
import script from "./InquiryDetailFormConfirm.vue?vue&type=script&lang=ts&"
export * from "./InquiryDetailFormConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports